export function WmsUiLibrary() {
  return <h1>Welcome to Wms UiLibrary!</h1>;
}

export default WmsUiLibrary;
